
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { Component, Vue } from 'vue-property-decorator';
import { ButtonPrimary } from '@warrenbrasil/nebraska-web';

import { trackSearchButtonClick } from '@/modules/trade/views/TradeView/trackers';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';

@Component({
  components: {
    ButtonPrimary
  }
})
export default class SearchButton extends Vue {
  private NebraskaColors = NebraskaColors;

  private goToSearch() {
    trackSearchButtonClick();
    this.$router.push({ name: 'tradeSearch' });
  }

  get label() {
    return this.isFinOneIntegrationWithTradeV0Enabled
      ? 'Negociar ativo'
      : 'Buscar ativo';
  }

  get isFinOneIntegrationWithTradeV0Enabled() {
    return FeatureFlagsModule.isEnabled(
      FeatureFlags.ENABLE_FIN_ONE_INTEGRATION_WITH_TRADE_V0
    );
  }
}
